'use client'

import Script from 'next/script'
import { useCallback, useEffect, useState } from 'react'

const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID
const COOKIE_KEY = 'cookie_consent'
const CONSENT_CHANGED_EVENT = 'consentChanged'

export const GoogleAnalytics: React.FC = () => {
  const [consent, setConsent] = useState<'accepted' | 'rejected' | null>(null)
  const [isClient, setIsClient] = useState(false)

  const updateConsentFromStorage = useCallback(() => {
    if (typeof window !== 'undefined') {
      const stored = window.localStorage.getItem(COOKIE_KEY)
      if (stored === 'accepted' || stored === 'rejected') {
        setConsent(stored)
      } else {
        setConsent(null)
      }
    }
  }, [])

  useEffect(() => {
    setIsClient(true)
    updateConsentFromStorage()

    window.addEventListener(CONSENT_CHANGED_EVENT, updateConsentFromStorage)

    return () => {
      window.removeEventListener(CONSENT_CHANGED_EVENT, updateConsentFromStorage)
    }
  }, [updateConsentFromStorage])

  if (!isClient || consent !== 'accepted' || !GA_MEASUREMENT_ID) {
    return null
  }

  return (
    <>
      <Script strategy="afterInteractive" src={`https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`} />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${GA_MEASUREMENT_ID}', {
              page_path: window.location.pathname,
            });
          `,
        }}
      />
    </>
  )
}
